import { render, staticRenderFns } from "./TaskPriorityPicker.vue?vue&type=template&id=56c139a3&scoped=true"
import script from "./TaskPriorityPicker.vue?vue&type=script&lang=js"
export * from "./TaskPriorityPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c139a3",
  null
  
)

export default component.exports